import * as React from 'react';
import classnames from 'classnames';

import Link from 'libs/router/Link';

import { getExternalUrl } from 'utils/url';
import { expandDataProps } from 'utils/helper/common';

import './action-link.scss';

import type { Data } from 'types';

type LinkType = {
  [x: string]: unknown
};

type Props = {
  children: React.ReactNode | undefined | null,
  link?: string | null,
  size: 'small' | 'normal' | 'medium' | 'big' | 'inherit',
  color: 'light' | 'secondary' | 'danger' | 'white' | 'primary' | 'dark',
  weight: 'normal' | 'bold',
  title?: string,
  transform?: 'uppercase',
  decoration?: 'none',
  inline?: boolean,
  openInNewTab: boolean,
  data?: Data,
  className: string,
  onClick?: (a: any) => Promise<any> | void | undefined | null
};

class ActionLink extends React.PureComponent<Props> {
  static defaultProps = {
    link: '',
    color: 'light',
    size: 'small',
    weight: 'normal',
    className: '',
    openInNewTab: false
  };

  getLinkProps(): LinkType {
    const { className, inline, transform, decoration, size, color, weight, onClick, title } = this.props;
    const linkProps: LinkType = {
      className: classnames({
        'action-link': true,
        'action-link--inline': inline,
        [`action-link--transform-${String(transform)}`]: transform,
        [`action-link--decoration-${String(decoration)}`]: decoration,
        [`action-link--size-${size}`]: size,
        [`action-link--color-${color}`]: color,
        [`action-link--weight-${weight}`]: weight,
        [className]: Boolean(className)
      })
    };

    if (onClick) {
      linkProps.onClick = onClick;
    }

    if (title) {
      linkProps.title = title;
    }

    return linkProps;
  }

  renderExternalLink(): React.ReactNode {
    const { children, data, link } = this.props;

    return (
      <a
        href={getExternalUrl(link)}
        rel="noopener noreferrer"
        target="_blank"
        {...this.getLinkProps()}
        {...expandDataProps(data)}
      >
        {children}
      </a>
    );
  }

  render(): React.ReactNode {
    const { children, openInNewTab, data, link } = this.props;

    if (link && link.toLowerCase().startsWith('http') || openInNewTab) { // external link
      return this.renderExternalLink();
    }

    if (link) {
      return (
        <Link
          to={link}
          {...this.getLinkProps()}
          {...expandDataProps(data)}
        >
          {children}
        </Link>
      );
    }

    return (
      <Link
        {...this.getLinkProps()}
        {...expandDataProps(data)}
      >
        {children}
      </Link>
    );
  }
}

export default ActionLink;
